package util

import Page
import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.js.json

private const val BootstrapKey = "__TIMBERIX_VIEWER_BOOTSTRAP"

object WebViewBootstrap {
    fun markLoading(page: Page) {
        publish(
            state = "loading",
            page = page.path,
        )
    }

    fun markReady(page: Page) {
        publish(
            state = "ready",
            page = page.path,
        )
    }

    fun markFailed(page: Page, message: String) {
        publish(
            state = "failed",
            page = page.path,
            message = message,
        )
    }

    private fun publish(state: String, page: String, message: String? = null) {
        val payload = json(
            "state" to state,
            "page" to page,
            "href" to window.location.href,
            "timestamp" to kotlin.js.Date().toISOString(),
            "message" to message,
        )

        val global = js("globalThis")
        global[BootstrapKey] = payload
        window.asDynamic()[BootstrapKey] = payload
        document.documentElement?.setAttribute("data-viewer-bootstrap-state", state)
        val bootstrapSetter = window.asDynamic().__TIMBERIX_setViewerBootstrap
        if (bootstrapSetter != null) {
            bootstrapSetter(payload)
        }
        notifyNative("viewerBootstrap", payload)
        if (state == "ready") {
            notifyNative("viewerReady", payload)
        }
    }

    private fun notifyNative(handlerName: String, payload: dynamic) {
        val webkitHandler = window.asDynamic().webkit?.messageHandlers?.get(handlerName)
        if (webkitHandler != null) {
            webkitHandler.postMessage(payload)
        }

        val androidBridge = window.asDynamic().AndroidViewerBridge
        if (androidBridge != null) {
            androidBridge.postMessage(JSON.stringify(payload))
        }
    }
}
